export const useClassNames = () => {
    return {
      classNames: (...classes) => {
        return classes.filter(Boolean).join(' ');
      }
    }
  }